module.exports = __webpack_public_path__ + "cbb9e3128a43f772c8eb8d0a6d66fb2c.jpeg";